// extracted by mini-css-extract-plugin
export default {"wrapper":"BalanceAndWithdraw_wrapper__cYhSz"};